import {Expose, Type} from 'class-transformer';
import {AbstractApiModel} from './abstract.api.model';
import {UserApiModel} from './user.api-model';

export class OwnerInvitationApiModel extends AbstractApiModel {
  @Expose() public id: number;
  @Expose() public owner: string | object;
  @Type(() => UserApiModel)
  @Expose() public invitedBy: UserApiModel | string;
  @Expose() public status: string;
  @Expose() public invitedByEmailAt: Date;
  @Expose() public invitedByNotificationAt: Date;
  @Expose() public acceptedAt: Date;
  @Expose() public deniedAt: Date;
}
